import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "checked"]
const _hoisted_2 = ["for", "innerHTML"]




export default /*@__PURE__*/_defineComponent({
  __name: 'px-checkbox',
  props: {
    label: {},
    value: {},
    checked: { type: Boolean },
    renderKey: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    key: props.renderKey,
    class: "px-checkbox"
  }, [
    _createElementVNode("input", {
      id: props.value,
      type: "checkbox",
      checked: props.checked
    }, null, 8, _hoisted_1),
    _createElementVNode("label", {
      for: props.value,
      innerHTML: props.label
    }, null, 8, _hoisted_2)
  ]))
}
}

})